let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dZ90g")).then(() => parcelRequire('9AIXr'));